import { CarSequenceMaintenanceComponent } from './pages/car-sequence-maintenance/car-sequence-maintenance.component';
import { LaasCalenderComponent } from './pages/laas-calender/laas-calender.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SettingRoutingModule } from './setting-routing.module';
import { CustomerChopSignComponent } from './pages/customer-chop-sign/customer-chop-sign.component';
import { LaaSSharedModule } from 'src/app/shared/laas-shared.module';
import { DoRuleSettingComponent } from './pages/do-rule-setting/do-rule-setting.component';
import { AddressMaintainanceComponent } from './pages/address-maintainance/address-maintainance.component';
import { EditTableComponent } from './components/edit-table/edit-table.component';
import { RfqSettingComponent } from './pages/rfq-setting/rfq-setting.component';
import { RfqCreationComponent } from './pages/rfq-creation/rfq-creation.component';
import { RfqHeaderDetailComponent } from './pages/rfq-header-detail/rfq-header-detail.component';
import { RfqHeaderEditComponent } from './pages/rfq-header-edit/rfq-header-edit.component';
import { RfqUploadComponent } from './pages/rfq-setting/rfq-upload/rfq-upload.component';
import { WarehouseCalendarComponent } from './pages/warehouse-calendar/warehouse-calendar.component';
import { WarehouseCalendarEditComponent } from './pages/warehouse-calendar-edit/warehouse-calendar-edit.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { FullCalendarModule } from '@fullcalendar/angular';
import { HubLabelSetupComponent } from './pages/hub-label-setup/hub-label-setup.component';



import { TariffRateSettingComponent } from './pages/tariff-rate-setting/tariff-rate-setting.component';
import { TariffRateSettingDetailComponent } from './pages/tariff-rate-setting-detail/tariff-rate-setting-detail.component';
import { TariffRateSettingEditComponent } from './pages/tariff-rate-setting-edit/tariff-rate-setting-edit.component';
import { TariffRateSettingAddComponent } from './pages/tariff-rate-setting-add/tariff-rate-setting-add.component';
import { AirwaysExpenseSettingComponent } from './pages/airways-expense-setting/airways-expense-setting.component';
import { AirwaysExpenseSettingDetailComponent } from './pages/airways-expense-setting-detail/airways-expense-setting-detail.component';
import { AirwaysExpenseSettingEditComponent } from './pages/airways-expense-setting-edit/airways-expense-setting-edit.component';
import { AirwaysExpenseSettingAddComponent } from './pages/airways-expense-setting-add/airways-expense-setting-add.component';
import { AirwaysExpenseSettingImportComponent } from './pages/airways-expense-setting/airways-expense-setting-import/airways-expense-setting-import.component';
import { TariffRateSettingImportComponent } from './pages/tariff-rate-setting/tariff-rate-setting-import/tariff-rate-setting-import.component';
import { DailyRateSettingComponent } from './pages/daily-rate-setting/daily-rate-setting.component';
import { DailyRateSettingAddComponent } from './pages/daily-rate-setting-add/daily-rate-setting-add.component';
import { DailyRateSettingEditComponent } from './pages/daily-rate-setting-edit/daily-rate-setting-edit.component';
import { DailyRateSettingDetailComponent } from './pages/daily-rate-setting-detail/daily-rate-setting-detail.component';
import { DailyRateSettingImportComponent } from './pages/daily-rate-setting/daily-rate-setting-import/daily-rate-setting-import.component';
import { AirportMaintenanceComponent } from './pages/ariport-maintenance/ariport-maintenance.component';
import { CityMaintenanceComponent } from './pages/city-maintenance/city-maintenance.component';
import { FacilityOptionMaintenanceComponent } from './pages/facility-option-maintenance/facility-option-maintenance.component';
import { AssignmentDistrictMaintenanceComponent } from './pages/assignment-district-maintenance/assignment-district-maintenance.component';
import { AreaMappingRFQMaintenanceComponent } from './pages/area-mapping-rfq-maintenance/area-mapping-rfq-maintenance.component';
import { AnnouncementComponent } from './pages/announcement/announcement.component';
import { AnnouncementEditComponent } from './pages/announcement-edit/announcement-edit.component';
import { AnnouncementViewComponent } from './pages/announcement-view/announcement-view.component';
import { FaqMaintenanceComponent } from './pages/faq-maintenance/faq-maintenance.component';
import { FaqEditComponent } from './pages/faq-edit/faq-edit.component';
import { DHLCityMaintenanceComponent } from './pages/dhl-city-maintenance/dhl-city-maintenance.component';
import { AutoPrintSettingComponent } from './pages/auto-print-setting/auto-print-setting.component';
import { FacilityPrinterComponent } from './pages/auto-print-setting/components/facility-printer/facility-printer.component';
import { AutoPrintSettingHeaderComponent } from './pages/auto-print-setting/components/auto-print-setting-header/auto-print-setting-header.component';
import { AutoPrintSettingDetailComponent } from './pages/auto-print-setting/components/auto-print-setting-detail/auto-print-setting-detail.component';
import { TermsViewComponent } from './pages/terms-view/terms-view.component';
import { ForwarderSettingComponent } from './pages/forwarder-setting/forwarder-setting.component';
import { ForwarderSettingExportComponent } from './pages/forwarder-setting-export/forwarder-setting-export.component';
import { ForwarderSettingRmbComponent } from './pages/forwarder-setting-rmb/forwarder-setting-rmb.component';
import { ForwarderSettingLocalComponent } from './pages/forwarder-setting-local/forwarder-setting-local.component';
import { WarehouseCalendarCopyComponent  } from './pages/warehouse-calendar-copy/warehouse-calendar-copy.component';
import { WarehouseCalendarCreateComponent  } from './pages/warehouse-calendar-create/warehouse-calendar-create.component';
import { ScheduleEffectiveTimeSettingComponent } from './pages/schedule-effective-time-setting/schedule-effective-time-setting.component';
import { UserFavoriteMenuComponent } from './pages/user-favorite-menu/user-favorite-menu.component';
import { HelpCenterSettingComponent } from './pages/help-center-setting/help-center-setting.component';
import { HelpCenterEditComponent } from './pages/help-center-setting/help-center-edit/help-center-edit.component';
import { HelpCenterFileEditComponent } from './pages/help-center-setting/help-center-file-edit/help-center-file-edit.component';
import { InvUploadMaintenanceComponent } from './pages/inv-upload-component/inv-upload-component.component';
import { CardModule } from 'primeng/card';
@NgModule({
    declarations: [
        AddressMaintainanceComponent,
        EditTableComponent,
        CustomerChopSignComponent,
        DoRuleSettingComponent,
        TariffRateSettingComponent,
        TariffRateSettingDetailComponent,
        WarehouseCalendarComponent,
        WarehouseCalendarEditComponent,
        AddressMaintainanceComponent,
        HubLabelSetupComponent,
        TariffRateSettingEditComponent,
        TariffRateSettingAddComponent,
        AirwaysExpenseSettingComponent,
        AirwaysExpenseSettingDetailComponent,
        AirwaysExpenseSettingEditComponent,
        AirwaysExpenseSettingAddComponent,
        RfqSettingComponent,
        RfqCreationComponent,
        RfqHeaderDetailComponent,
        RfqHeaderEditComponent,
        RfqUploadComponent,
        AirwaysExpenseSettingImportComponent,
        TariffRateSettingImportComponent,
        DailyRateSettingComponent,
        DailyRateSettingAddComponent,
        DailyRateSettingEditComponent,
        DailyRateSettingDetailComponent,
        DailyRateSettingImportComponent,
        AirportMaintenanceComponent,
        CityMaintenanceComponent,
        FacilityOptionMaintenanceComponent,
        AssignmentDistrictMaintenanceComponent,
        AreaMappingRFQMaintenanceComponent,
        AnnouncementComponent,
        AnnouncementEditComponent,
        AnnouncementViewComponent,
        LaasCalenderComponent,
        FaqMaintenanceComponent,
        FaqEditComponent,
        CarSequenceMaintenanceComponent,
        DHLCityMaintenanceComponent,
        AutoPrintSettingComponent,
        FacilityPrinterComponent,
        AutoPrintSettingHeaderComponent,
        AutoPrintSettingDetailComponent,
        TermsViewComponent,
        ForwarderSettingComponent,
        ForwarderSettingExportComponent,
        ForwarderSettingRmbComponent,
        ForwarderSettingLocalComponent,
        WarehouseCalendarCreateComponent,
        WarehouseCalendarCopyComponent,
        ScheduleEffectiveTimeSettingComponent,
        UserFavoriteMenuComponent,
        HelpCenterSettingComponent,
        HelpCenterEditComponent,
        HelpCenterFileEditComponent,
        InvUploadMaintenanceComponent
    ],
    exports: [
        AddressMaintainanceComponent
    ],
    imports: [
        CommonModule,
        SettingRoutingModule,
        LaaSSharedModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        FullCalendarModule,
        CardModule
    ]
})
export class SettingModule { }
